// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_124_g","inverse":"index_inverse_2MpNM","item":"index_item_1xTBo","body":"index_body_3wNRf","icon":"index_icon_2BygW"};